module.exports = __webpack_public_path__ + "media/images/flags/IO-db1d513a3406e0a6c6f4687a883c6df1.svg";